import styled from "styled-components";
import { useAppSelector } from "../../hooks";
import { Select } from "antd";
import { useSearchParams } from "react-router-dom";

export const TablePicker = styled(BaseTablePicker)`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .error {
    color: rgb(var(--color-danger-rgb));
    font-weight: 600;
  }
`

interface ITablePicker {
  className?: string,
  error?: string
}

function BaseTablePicker({className, error}: ITablePicker) {

  const numberOfTables = useAppSelector((state) => state.store.details?.numberOfTables)
  const partnerUrlName = useAppSelector((state) => state.store.details?.urlName)

  const [searchParams] = useSearchParams();
  let tableNumber = searchParams.get("table");
  
  const handleChange = ((val: number) => {
    window.location.href = `/${partnerUrlName}?table=${val}`
  })

  return (
    <>
      {
        numberOfTables &&
        <div className={className}>
          {
            error &&
            <span className="error">{error}</span>
          }
          <Select
            defaultValue={tableNumber && parseInt(tableNumber) <= numberOfTables ? parseInt(tableNumber) : undefined}
            style={{ width: 120 }}
            onChange={handleChange}
            options={
              Array.from({length: numberOfTables}, (_, i) => {
                return {
                  value: i + 1,
                  label: `Table ${i + 1}`
                }
              })}
          />
        </div>
      }
    </>
  )
}